import { makeStyles } from '@material-ui/core/styles';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(theme => ({
  mergeTransactionContainer: {
    paddingLeft: 10,
    paddingRight: 10,
    justifyContent: 'space-between',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  title: {
    color: themeColor.modalTitle,
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  titleBar: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  content: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  descriptionContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 2,
  },
  descriptionLabel: {
    color: themeColor.modalTitle,
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(2.5),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(2),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.1),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.5),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1.4),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(1.2),
    },
  },
  transactionListButton: {
    marginLeft: '0.5vw',
  },
}));
